import { createGlobalStyle } from "styled-components";
import { theme } from "./appTheme";

const pcBackground = new URL("../assets/images/bg_PC.jpg", import.meta.url).href;

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: ${theme.palette.background};
    color: ${theme.palette.text};
    font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", "YuGothic", sans-serif;
  }

  /* PC 幅では中央カラムの外側に街並みを敷く（スマホでは見えないので読み込ませない） */
  @media (min-width: 768px) {
    body {
      background: ${theme.palette.background} url(${pcBackground}) center / cover no-repeat fixed;
    }
  }

  input,
  button,
  textarea,
  select {
    font-family: inherit;
  }
`;
